import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { withDefaults, ref, watch, onMounted } from 'vue';

interface IProps {
  modelValue: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeTabWindow',
  props: {
    modelValue: { default: '' }
  },
  setup(__props: any) {

const props = __props;
const tab = ref(props.modelValue);

watch(
  () => props.modelValue,
  () => {
    tab.value = props.modelValue;
  }
);
onMounted(() => {
  if (props.modelValue) tab.value = props.modelValue;
});

return (_ctx: any,_cache: any) => {
  const _component_v_window = _resolveComponent("v-window")!

  return (_openBlock(), _createBlock(_component_v_window, {
    modelValue: tab.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tab).value = $event))
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["modelValue"]))
}
}

})